// auto-generated by Typewriter template _models.tst from PortCall.Models\DomainSettings\PushNotificationSettings.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// PushNotificationSettingsData is the class that PushNotificationSettings serializes to/from
export interface PushNotificationSettingsData {
	
	
    SendAsEmail : boolean;
}

// PushNotificationSettingsOptions is the class which may be passed to the PushNotificationSettings constructor to define optional initial data values
export interface PushNotificationSettingsOptions {
	
	
    SendAsEmail? : boolean;
}

export class PushNotificationSettings {
	
	
    public SendAsEmail : DataSignal<boolean>;

    constructor();
    constructor(data : PushNotificationSettingsOptions);
    constructor(data: PushNotificationSettingsOptions | null = null) {
	    
	    
        this.SendAsEmail = jsonableObservable(S.value<boolean>(data && data.SendAsEmail !== undefined ? data.SendAsEmail : false));
    }

    static key(obj : PushNotificationSettings) {
        return ;
    }
    
    static dataKey(obj : PushNotificationSettingsOptions) {
        return ;
    }

    static update(obj : PushNotificationSettings, data : PushNotificationSettingsOptions) {
        S.freeze(() => {
	        
	        
            if (data.SendAsEmail !== undefined) obj.SendAsEmail(data.SendAsEmail);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PushNotificationSettings.ts